import ansis from 'ansis';
import { isObject } from './isObject';
const NEWLINE_CHAR = '\r\n';
export const stringifyErrorObject = (error, leftPad = '') => {
  let result = leftPad;
  if (error.stack) {
    const stackLinesAsArray = error.stack.split('\n').map(line => ansis.dim(`${leftPad}${line}`));
    result += stackLinesAsArray.join(NEWLINE_CHAR);
  } else {
    // When stack is not defined then just simulate atleast its first line from name and message
    result += ansis.bold(`${error.name || 'Error'}: ${error.message}`);
  }
  if (isObject(error.cause)) {
    result += `${NEWLINE_CHAR}${leftPad}Cause:${NEWLINE_CHAR}`;
    result += stringifyErrorObject(error.cause, leftPad);
  }
  return result;
};
//# sourceMappingURL=stringifyErrorObject.js.map